import React from 'react'
import { updateTickets, stopChange } from '../../helpers/price-type-logic'
import classNames from 'classnames'

const onClickTicketChange = (delta, ticket, item, step, updateItem) => _ => {
  let newTicket = ticket
  let newItem = item
  newTicket.quantity += delta
  let [ticketInCart, newTickets] = updateTickets(newItem, newTicket, step)
  if (!ticketInCart) {
    newTickets = [...newTickets, newTicket]
  }
  newItem.tickets = newTickets
  updateItem(newItem)
}

function StepperButton({
  controls,
  children,
  delta,
  hitMaximumsByAge,
  item,
  minimums,
  stopDecrement,
  stopIncrement,
  noVacancy,
  step,
  ticket,
  updateItem
}) {
  const [noIncrement, noDecrement] = stopChange(
    delta,
    ticket,
    step,
    minimums,
    hitMaximumsByAge,
    stopDecrement,
    stopIncrement
  )
  const isDisabled = delta === -1 ? noDecrement : noVacancy || noIncrement
  let className = classNames(
    'border border-depths rounded-full w-32 h-32 font-bold text-21 text-depths leading-none',
    {
      'cursor-default': isDisabled
    }
  )
  let style = {
    opacity: isDisabled ? 0.4 : 1
  }

  return (
    <button
      className={className}
      style={style}
      onClick={onClickTicketChange(delta, ticket, item, step, updateItem)}
      disabled={isDisabled}
      aria-controls={controls}
    >
      {children}
    </button>
  )
}

export default StepperButton
